/**
 * Naming for the new version CENTERLINE creates from Bluebeam markups.
 *
 * The posted filename is suggested as soon as the markup session is launched, so the architect
 * sees the name the flattened version will carry instead of being asked for one afterwards. The
 * suggestion is the current filename with a "-NN" version suffix: a file that has never been
 * versioned this way becomes "-02" (the file being marked up is version 01), and a file that
 * already carries a suffix has that number incremented -- "Plan-02" becomes "Plan-03" rather than
 * "Plan-02-02", so a file marked up repeatedly does not collect a tail of numbers.
 */

/** Matches a trailing "-NN" version suffix, capturing the digits so their width is preserved. */
const VERSION_SUFFIX = /-(\d+)$/;

/**
 * @param baseName the filename without its extension -- what the "Posted filename" field holds.
 */
export function getNextBluebeamVersionName(baseName: string): string {
  const trimmed = baseName.trim();
  if (!trimmed) return '';

  const match = trimmed.match(VERSION_SUFFIX);
  if (!match) return `${trimmed}-02`;

  const [suffix, digits] = match;
  const next = String(Number(digits) + 1).padStart(digits.length, '0');
  return `${trimmed.slice(0, trimmed.length - suffix.length)}-${next}`;
}
